import React from "react";
import Uri from "jsuri";

import client from "client";
import { ApolloProvider } from "@apollo/client";

import DefaultQuery from "./DefaultQuery";
import { QUERY_USERS } from "./UserQueries";

import Users from "./Users";

// Utility function to escape HTML characters
const escapeHtml = (text) => {
  if (!text) return text;
  return text.replace(/[<>&"']/g, (match) => {
    const escapeMap = {
      "<": "&lt;",
      ">": "&gt;",
      "&": "&amp;",
      '"': "&quot;",
      "'": "&#x27;",
    };
    return escapeMap[match];
  });
};

const UsersContainer = () => {
  const uri = new Uri(window.location.href);

  const deleted_first = uri.getQueryParamValue("deleted_first");
  const deleted_last = uri.getQueryParamValue("deleted_last");

  const created_first = uri.getQueryParamValue("created_first");
  const created_last = uri.getQueryParamValue("created_last");

  return (
    <div className="container-wrapper">
      <div className="container-fluid">
        <main className="container-main">
          {deleted_first && deleted_last && (
            <div className="alert alert-success mr-2 ml-2" role="alert">
              User <b>{escapeHtml(deleted_first)}</b>{" "}
              <b>{escapeHtml(deleted_last)}</b> has been deleted.
            </div>
          )}

          {created_first && created_last && (
            <div className="alert alert-success mr-2 ml-2" role="alert">
              User <b>{escapeHtml(created_first)}</b>{" "}
              <b>{escapeHtml(created_last)}</b> has been created.
            </div>
          )}

          <ApolloProvider client={client}>
            <DefaultQuery
              query={QUERY_USERS}
              variables={{
                tenantID: parseInt(localStorage.defaultTenantID),
              }}
            >
              {({ data: { users } }) => <Users data={users} />}
            </DefaultQuery>
          </ApolloProvider>
        </main>
      </div>
    </div>
  );
};

export default UsersContainer;
